/**
 * OPS-PHASE1-009 — canonical FONE workflow permission keys.
 * Must stay aligned with parentlib WorkflowPermissionKeys.java and V017–V021 workflow groups.
 */

export const WORKFLOW_PERMISSION_KEYS = Object.freeze({
  GRANT_ALL: 'FONE:HMSOPERATIONSALL',

  BILLING_WORKSPACE: 'FONE:BILLINGWORKSPACE',
  BILLING_PAYMENT: 'FONE:BILLINGPAYMENT',
  OP_BILLING_COUNTER: 'FONE:OPBILLINGCOUNTER',
  REFUND_REQUEST: 'FONE:REFUNDREQUEST',
  REFUND_REVIEW: 'FONE:REFUNDREVIEW',
  SHIFT_OPEN: 'FONE:SHIFTOPEN',
  SHIFT_CLOSE: 'FONE:SHIFTCLOSE',
  SHIFT_RECOVERED_CLOSE: 'FONE:SHIFTRECOVEREDCLOSE',
  SHIFT_CONTINUITY: 'FONE:SHIFTCONTINUITY',
  PRINT_RECEIPT: 'FONE:PRINTRECEIPT',
  IP_DISCHARGE: 'FONE:IPDISCHARGE',
  INPATIENT: 'FONE:INPATIENT',
  OPERATIONAL_ALERTS: 'FONE:OPERATIONALALERTS',
  COUNTER_FINANCE_AUDIT: 'FONE:COUNTERFINANCEAUDIT',
  FINANCE_CLOSE: 'FONE:FINANCECLOSE',
  OPERATIONAL_APPROVALS: 'FONE:OPERATIONALAPPROVALS',

  PATIENTS: 'FONE:PATIENTS',
  PATIENT_TOKEN: 'FONE:PATIENTTOKEN',
  PATIENT_JOURNEY: 'FONE:PATIENTJOURNEY',

  OPD_CONSULTATION: 'FONE:OPDCONSULTATION',
  CLINICAL_RECOMMENDATIONS: 'FONE:CLINICALRECOMMENDATIONS',
  CLINICAL_ACTION: 'FONE:CLINICALACTION',

  LAB_ACTION: 'FONE:LABACTION',
  LAB_COUNTER: 'FONE:LABCOUNTER',
  LAB_COLLECTION: 'FONE:LABCOLLECTION',
  LAB_RESULT_ENTRY: 'FONE:LABRESULTENTRY',
  LAB_VERIFICATION: 'FONE:LABVERIFICATION',
  LAB_PRINT_QUEUE: 'FONE:LABPRINTQUEUE',

  RAD_ACTION: 'FONE:RADACTION',
  RADIOLOGY_COUNTER: 'FONE:RADIOLOGYCOUNTER',
  RADIOLOGY_SCHEDULING: 'FONE:RADIOLOGYSCHEDULING',
  RADIOLOGY_TECHNICIAN: 'FONE:RADIOLOGYTECHNICIAN',
  RADIOLOGY_REPORT_ENTRY: 'FONE:RADIOLOGYREPORTENTRY',
  RADIOLOGY_VERIFICATION: 'FONE:RADIOLOGYVERIFICATION',
  RADIOLOGY_PRINT_QUEUE: 'FONE:RADIOLOGYPRINTQUEUE',

  PHARMACY_ACTION: 'FONE:PHARMACYACTION',
  PHARMACY_COUNTER: 'FONE:PHARMACYCOUNTER',
  PHARMACY_ISSUE: 'FONE:PHARMACYISSUE',
  PHARMACY_RETURNS: 'FONE:PHARMACYRETURNS',
  PHARMACY_PRINT_QUEUE: 'FONE:PHARMACYPRINTQUEUE',
  PHARMACY_MASTER: 'FONE:PHARMACYMASTER',
  PHARMACY_MASTER_ENTERPRISE: 'FONE:PHARMACYMASTERENTERPRISE',
  PHARMACY_MASTER_HOSPITAL: 'FONE:PHARMACYMASTERHOSPITAL',
  PHARMACY_PROCURE: 'FONE:PHARMACYPROCURE',
  PHARMACY_GRN: 'FONE:PHARMACYGRN',
  PHARMACY_BILL: 'FONE:PHARMACYBILL',
  PHARMACY_ADJUST: 'FONE:PHARMACYADJUST',
  PHARMACY_REPORT: 'FONE:PHARMACYREPORT',
  PHARMACY_INVENTORY: 'FONE:PHARMACYINVENTORY',

  PATIENT_BILLING_DUES: 'FONE:PATIENTBILLINGDUES',
  PATIENT_BILLING_DUES_INVOICES: 'FONE:PATIENTBILLINGDUES:INVOICES',
  PATIENT_BILLING_DUES_PAYMENTS: 'FONE:PATIENTBILLINGDUES:PAYMENTS',
  PATIENT_BILLING_DUES_COLLECT: 'FONE:PATIENTBILLINGDUES:COLLECT',
  PATIENT_BILLING_DUES_PRINT: 'FONE:PATIENTBILLINGDUES:PRINT',
  PATIENT_BILLING_DUES_MODULE_PHARMACY: 'FONE:PATIENTBILLINGDUES:MODULE:PHARMACY',
  PATIENT_BILLING_DUES_MODULE_LABORATORY: 'FONE:PATIENTBILLINGDUES:MODULE:LABORATORY',
  PATIENT_BILLING_DUES_MODULE_RADIOLOGY: 'FONE:PATIENTBILLINGDUES:MODULE:RADIOLOGY',
  PATIENT_BILLING_DUES_MODULE_OT: 'FONE:PATIENTBILLINGDUES:MODULE:OT',
  PATIENT_BILLING_DUES_MODULE_BILLING: 'FONE:PATIENTBILLINGDUES:MODULE:BILLING',
});

/** All canonical workflow keys (for parity audits). */
export const WORKFLOW_PERMISSION_KEY_LIST = Object.freeze(Object.values(WORKFLOW_PERMISSION_KEYS));
